"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DescriptionCardCms = void 0;
var DescriptionCardCms = /** @class */ (function () {
    function DescriptionCardCms() {
        this.messageHeading = 'Heads up: ';
        this.dualCalendarInfo = "Based on your availability, your {0} and {1} may\n    need to be installed on separate days. Please schedule an appointment below\n    for each service.";
        this.firstAvailableAppointmentLabel = 'Keep in mind installations usually take about 4 hours.';
        this.panelDescriptionDualLabel = "Keep in mind that EACH installation can take up to 4 hours.";
        this.goodNewsMessage = 'Good news. We can install your service tomorrow!';
        this.liveCalendarDisconnectLabel = "Looks like there's a pending disconnect order for the existing\n    service at your address. Our first available appointment shown below is after that order completes.";
        this.preferenceCalendarDisconnectLabel = "Looks like there's a pending disconnect order for the existing\n    service at your address. Your appointment will be scheduled after that order completes.";
        this.acmeDevicesLabel = "Installation is only available for your internet service and AT&T TV device(s)\n    and can take up to 4 hours. Your devices will be shipped to you, but you should get them\n    before our first available appointment shown below.";
        this.acmeAppleDeviceLabel = "Installation is only available for your internet service\n    and can take up to 4 hours.";
        this.bbInstallationLabel = "Your internet installation and setup of your\n    AT&T TV device(s) can take up to 4 hours. Your devices will be shipped to you,\n    but you should get them before our first available appointment shown below.";
    }
    return DescriptionCardCms;
}());
exports.DescriptionCardCms = DescriptionCardCms;
//# sourceMappingURL=DescriptionCard.cms.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/checkout-ui/components/panels/ScheduleInstallPanel/DescriptionCard/DescriptionCard.cms.js
// module id = 968
// module chunks = 8